import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Button, Intent } from "@blueprintjs/core";
import { tidyUpSequenceData } from "@teselagen/sequence-utils";
import { DataTable } from "@teselagen/ui";
import Editor from "../Editor";
import FillWindow from "../Editor/FillWindow";
import withEditorProps from "../withEditorProps";
import { noop } from "lodash-es";
const SIDE_PANEL_WIDTH = 350;
const currentVersion = {
  dateChanged: "Current",
  id: "__current__"
};
export class VersionHistoryView extends React.Component {
  state = {
    selectedVersion: void 0,
    versionList: [currentVersion]
  };
  // static defaultProps = {
  //   getVersionList: () => {
  //     return [
  //       {
  //         dateChanged: "12/30/2211",
  //         editedBy: "thomas",
  //         revisionType: "thomas",
  //         versionId: 2
  //       }
  //     ];
  //   }
  // };
  updateSeqData = (sequenceData) => {
    this.activeSeqData = sequenceData;
    this.props.vectorEditorInitialize(
      {
        sequenceData: sequenceData && tidyUpSequenceData(sequenceData) || tidyUpSequenceData({
          sequence: "gTAGAGACAAGA"
        })
      },
      {
        editorName: "veVersionHistoryView"
      }
    );
  };
  componentDidMount = async () => {
    this._getVersionList();
    await this.updateSeqData(await this.getCurrentSeqData());
  };
  getCurrentSeqData = async () => {
    if (this.props.getCurrentSequenceData) {
      return await this.props.getCurrentSequenceData();
    } else {
      return this.props.sequenceData;
    }
  };
  onRowSelect = async ([row]) => {
    if (!row) return;
    if (row.id === "__current__") {
      this.updateSeqData(await this.getCurrentSeqData());
      this.setState({ selectedVersion: null });
    } else {
      this.updateSeqData(await this.props.getSequenceAtVersion(row.versionId));
      this.setState({ selectedVersion: row });
    }
  };
  _getVersionList = async () => {
    const versionList = await this.props.getVersionList();
    this.setState({
      versionList: [
        currentVersion,
        ...versionList.map((r) => {
          return { ...r, id: r.versionId };
        })
      ]
      //currentVersion should always come first
    });
  };
  revertToSelectedVersion = () => {
    if (!this.props.onSave) {
      return console.error("props.onSave must be passed to VersionHistoryView");
    }
    const tidiedActiveData = tidyUpSequenceData(this.activeSeqData, {
      annotationsAsObjects: true
    });
    this.props.updateSequenceData && this.props.updateSequenceData(tidiedActiveData);
    this.props.caretPositionUpdate && this.props.caretPositionUpdate(0);
    this.props.onSave(
      {},
      tidiedActiveData,
      {},
      //empty editor props
      noop
      //empty unSuccessCallback
    );
    this.goBack();
  };
  goBack = () => {
    this.props.exitVersionHistoryView && this.props.exitVersionHistoryView();
    this.props.toggleViewVersionHistory();
  };
  render() {
    return /* @__PURE__ */ jsx(FillWindow, { asPortal: true, className: "veVersionHistoryViewContainer", children: ({ width, height }) => {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          style: { width, height, display: "flex" },
          className: "veVersionHistoryView",
          children: [
            /* @__PURE__ */ jsx(
              Editor,
              {
                style: {
                  flexBasis: "content",
                  // flex: "0 0 200px",
                  flex: "1 1 350px",
                  width: width - SIDE_PANEL_WIDTH
                },
                noVersionHistory: true,
                ToolBarProps: {
                  toolList: [
                    "cutsiteTool",
                    "featureTool",
                    "orfTool",
                    "alignmentTool",
                    "findTool",
                    "visibilityTool"
                  ],
                  contentLeft: /* @__PURE__ */ jsx(
                    Button,
                    {
                      onClick: this.goBack,
                      icon: "arrow-left",
                      style: { marginLeft: 5, marginRight: 5 },
                      children: "Back"
                    }
                  )
                },
                editorName: "veVersionHistoryView"
              }
            ),
            /* @__PURE__ */ jsxs(
              "div",
              {
                style: {
                  borderLeft: "1px solid grey",
                  padding: 3,
                  width: SIDE_PANEL_WIDTH,
                  minWidth: SIDE_PANEL_WIDTH,
                  // flexBasis: 350,
                  // width: 350,
                  // flexGrow: 1,
                  // flex: "2 1 350px",
                  // flexBasis: "content",
                  display: "flex",
                  flexDirection: "column"
                },
                className: "veVersionHistoryViewSidePanel",
                children: [
                  /* @__PURE__ */ jsxs("h2", { style: { width: "100%", textAlign: "center" }, children: [
                    " ",
                    "Past Versions:",
                    " "
                  ] }),
                  /* @__PURE__ */ jsx(
                    DataTable,
                    {
                      noPadding: true,
                      isSingleSelect: true,
                      noDeselectAll: true,
                      noFullscreenButton: true,
                      onRowSelect: this.onRowSelect,
                      maxHeight: 400,
                      formName: "featureProperties",
                      noRouter: true,
                      compact: true,
                      selectedIds: ["__current__"],
                      withDisplayOptions: true,
                      hideDisplayOptionsIcon: true,
                      withSearch: false,
                      name: "veVersionHistoryView",
                      isInfinite: true,
                      schema: {
                        fields: [
                          {
                            path: "dateChanged",
                            type: "string"
                          },
                          { path: "editedBy", type: "string" },
                          { path: "revisionType", type: "string" }
                        ]
                      },
                      entities: this.state.versionList
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      style: { margin: 3 },
                      intent: Intent.PRIMARY,
                      disabled: !this.state.selectedVersion,
                      onClick: this.revertToSelectedVersion,
                      text: "Revert to Selected Version"
                    }
                  )
                ]
              }
            )
          ]
        }
      );
    } });
  }
}
export default withEditorProps(VersionHistoryView);
